import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Form, Typography, Table, Button, Input, Icon, Tag, Modal } from 'antd'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'
import { green } from '@material-ui/core/colors'
import 'antd/dist/antd.css'
import Highlighter from 'react-highlight-words'
import Format from '../../../utils/format'
import { Markup } from 'interweave';

const { Title } = Typography;

@inject(
    'webSettingStore',
    'spaOfferStore'
)
@observer
class SpaOfferList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
        this.props.webSettingStore.getData();
    }

    createClicked = () => this.props.spaOfferStore.initCreate()
    updateClicked = spaOfferId => this.props.spaOfferStore.initUpdate(spaOfferId)
    removeClicked = spaOfferId => this.props.spaOfferStore.deleteSpaOffer(spaOfferId)

    deleteClicked = spaOfferId => {
        Modal.confirm({
            title: 'Remove Shopping Offer',
            content: 'Are you sure to remove this offer?',
            okText: 'Remove',
            cancelText: 'Cancel',
            onOk: () => this.removeClicked(spaOfferId)
        });
    }

    getColumns = () => {
        const { data: webSettting } = this.props.webSettingStore;

        return [
            {
                title: 'Title',
                dataIndex: 'title',
                key: 'title',
                ...this.getColumnSearchProps('title')
            },
            {
                title: 'Item Name',
                dataIndex: 'taskName',
                key: 'taskName',
                ...this.getColumnSearchProps('taskName')
            },
            {
                title: 'Brief Desc',
                dataIndex: 'briefDesc',
                key: 'briefDesc',
                ...this.getColumnSearchProps('briefDesc'),
                render: briefDesc => (
                    <Markup content={briefDesc} />
                )
            },
            {
                title: 'Original Price',
                dataIndex: 'originalPrice',
                key: 'originalPrice',
                render: originalPrice => (
                    <Tag color={'blue'} style={{ fontSize: 14, padding: '5px 15px 5px 15px' }}>
                        {webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}
                    </Tag>
                )
            },
            {
                title: 'Special Price',
                dataIndex: 'price',
                key: 'price',
                render: price => (
                    <Tag color={'green'} style={{ fontSize: 14, padding: '5px 15px 5px 15px' }}>
                        {webSettting ? webSettting.currencyCode : ''} {Format.Currency(price)}
                    </Tag>
                )
            },
            {
                title: 'Start Date',
                dataIndex: 'startDate',
                key: 'startDate',
            },
            {
                title: 'End Date',
                dataIndex: 'endDate',
                key: 'endDate',
            },
            {
                title: 'Sort',
                dataIndex: 'sort',
                key: 'sort',
            },
            {
                title: 'Action',
                dataIndex: 'spaOfferId',
                key: 'action',
                render: spaOfferId => (
                    <span>
                        <Button onClick={() => this.updateClicked(spaOfferId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteClicked(spaOfferId)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type='primary'
                    onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    icon='search'
                    size='small'
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const {
            spaOffers
        } = this.props.spaOfferStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>Devarana Wellness Offer List</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createClicked}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Table columns={this.getColumns()} dataSource={spaOffers} />
                </Form>
            </React.Fragment>
        )
    }
}

export default SpaOfferList